import { DossierSectionId } from '../../../constants/bankDossier';
import {
  IconBankMS,
  IconContactsMS,
  IconFolderOpenMS,
  IconHistoryMS,
  IconHubMS,
  IconPaidMS,
  IconRequestQuoteMS,
} from '../../../constants/icons';

export const sectionIcons: Record<DossierSectionId, JSX.Element> = {
  financing: IconRequestQuoteMS,
  timeline: IconHistoryMS,
  parties: IconBankMS,
  contacts: IconContactsMS,
  charges: IconPaidMS,
  files: IconFolderOpenMS,
  related: IconHubMS,
};
